var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 62,
    rx: 8,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 25.334C37.0416 25.334 42.75 23.4312 42.75 21.084C42.75 18.7368 37.0416 16.834 30 16.834C22.9584 16.834 17.25 18.7368 17.25 21.084C17.25 23.4312 22.9584 25.334 30 25.334Z",
    stroke: "#3B70E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2501 21.084V40.9173C17.2422 41.5986 17.7258 42.2706 18.6601 42.8765C19.5945 43.4825 20.9522 44.0047 22.6187 44.3991C24.2853 44.7935 26.212 45.0486 28.2362 45.1429C30.2605 45.2371 32.3231 45.1678 34.2501 44.9407",
    stroke: "#3B70E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 21.084V25.334",
    stroke: "#3B70E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 31L38.5 38.0833H44.1667L39.9167 45.1667",
    stroke: "#3B70E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 31C17.252 31.6623 17.7185 32.3153 18.6121 32.9069C19.5056 33.4985 20.8017 34.0123 22.3967 34.4072C23.9917 34.8022 25.8416 35.0675 27.7988 35.1818C29.756 35.2962 31.7662 35.2564 33.6692 35.0658",
    stroke: "#3B70E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRequestIcon);
export default __webpack_public_path__ + "static/media/total-request-icon.aadbabded8ba402f92cf03a4d09f4e8d.svg";
export { ForwardRef as ReactComponent };